<template>
    <div class="contact-details">
        <div class="user-info-profile" v-if="showProfileTop">
            <div class="profile-header" :class="{ minimized: isMinimized }">
                <div class="profile-top-row">
                    <div class="profile-main" @click="viewContactProfile">
                        <div class="avatar-wrapper" :class="{ minimized: isMinimized }">
                            <ContactAvatar
                                :contact="contact"
                                :key="contact._id"
                                :badge="true"
                                :badge-type="IsVisitorOnline() ? 'visitor-online' : 'visitor-offline'"
                            />
                            <div class="platform-badge" v-tippy="{ content: getPlatformName() }">

                                <WhatsappIcon
                                    v-if="contact.platform === 'whatsapp'"
                                    color="#25D366"
                                    class="platform-icon"
                                />
                                <TelegramIcon v-else-if="contact.platform === 'telegram'" class="platform-icon" />
                                <MessengerIcon v-else-if="contact.platform === 'messenger'" class="platform-icon" />
                                <LinkedinIcon v-else-if="contact.platform === 'linkedin'" class="platform-icon" />
                                <webIcon v-else-if="contact.platform === 'web'" class="platform-icon" color="black;" />
                                <mailIcon v-else-if="contact.platform === 'email'" class="platform-icon" />
                                <MetaIcon v-else-if="contact.platform === 'meta-leads'" class="platform-icon" />
                                <TrendyolIcon v-else-if="contact.platform === 'trendyol'" class="platform-icon" />
                                <InstagramIcon
                                    v-else-if="contact.platform === 'instagram'"
                                    class="platform-icon"
                                    special-background-mode
                                />
                            </div>
                        </div>
                    <div class="name-info">
                        <div class="name-row">
                            <div class="contact-profile-fullname">
                                {{ getVal("fullname") }}
                                <a 
                                    v-if="contact.instagramInfo && contact.instagramInfo.username" 
                                    class="instagram-username"
                                    :href="`https://www.instagram.com/${contact.instagramInfo.username}`"
                                    target="_blank"
                                    @click.stop
                                >
                                    @{{ contact.instagramInfo.username }}
                                </a>
                            </div>
                            <div
                                    class="vip-star-btn"
                            :class="{ active: contact.vipCustomer }"
                            @click.stop="toggleVipCustomer"
                            v-tippy="{ content: contact.vipCustomer ? $t('chat.contactDetail.removeVIPTooltip') : $t('chat.contactDetail.markAsVIPTooltip') }"
                        >
                            <i class="material-icons">star</i>
                                </div>
                        </div>
                        <div
                                v-if="contact.platform === 'whatsapp'"
                                class="whatsapp-number"
                                @click.stop="showWhatsappChatStarterModal = true"
                            >
                                <a href="javascript:void(0)">{{ maskContactInfo("phone", contact.whatsappNumber, 5) }}</a>
                        </div>
                        <div v-if="contact.platform === 'instagram'" class="instagram-follow-info">
                            <div v-if="getInstagramFollowInfo().userFollowsBusiness" class="follow-badge user-follows">
                                <i class="material-icons">check_circle</i>
                                <span>Sizi takip ediyor</span>
                            </div>
                            <div v-if="getInstagramFollowInfo().businessFollowsUser" class="follow-badge business-follows">
                                <i class="material-icons">check_circle</i>
                                <span>Takip ediyorsunuz</span>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                <div class="profile-meta-section">
                    <div class="meta-label">{{ $t('chat.contactDetail.customerOwnership') }}</div>
                    <div class="meta-content">
                        <div class="owner-row">
                            <div
                                class="owner-info"
                                @click.stop="showOwnerModal = true"
                                v-tippy="{ content: $t('chat.contactDetail.ownershipDescription') }"
                            >
                                <AgentAvatar v-if="getOwnerName(contact.owner)" :userID="contact.owner" :size="18" />
                                <span class="owner-name">{{ getOwnerName(contact.owner) || $t('chat.contactDetail.unowned') }}</span>
                                <i class="material-icons owner-settings-icon">settings</i>
                            </div>
                            <div class="owner-actions">
                                <button
                                    class="owner-action-btn assign-to-me-btn"
                                    @click.stop="assignToMe"
                                    v-if="contact.owner !== authUser._id"
                                    v-tippy="{ content: $t('chat.contactDetail.assignToMe') }"
                                >
                                    <i class="material-icons">person_add</i>
                                </button>
                                <button
                                    class="owner-action-btn remove-owner-btn"
                                    @click.stop="removeOwner"
                                    v-if="contact.owner"
                                    v-tippy="{ content: $t('chat.contactDetail.removeOwnership') }"
                                >
                                    <i class="material-icons">person_remove</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal2
            v-if="showWhatsappChatStarterModal"
            @cancel="showWhatsappChatStarterModal = false"
            :title="$t('message.whatsappChatStart')"
            :showFooter="false"
        >
            <WhatsappChatStarter
                :default-phone-number="isMaskContactInfo('whatsappNumber') ? '' : contact.whatsappNumber"
                channel-override
                phone-number-override
                @close="showWhatsappChatStarterModal = false"
                :default-email="isMaskContactInfo('email') ? '' : contact.email"
                :default-name="isShouldMask(contact.name || contact.fullname) ? '' : (contact.name || contact.fullname)"
            />
        </Modal2>
        <Modal2
            v-if="showOwnerModal"
            :title="$t('message.transferOwnership')"
            @cancel="showOwnerModal = false"
            :showFooter="false"
            xlarge
        >
            <ChatForwardWindow
                :contact="contact"
                @close="showOwnerModal = false"
            />
        </Modal2>
        <div class="user-info-details-wrapper">
            <div class="user-info-details-content" ref="groupsContainer">
                <div
                    v-for="(groupKey, idx) in groupOrder"
                    :key="groupKey"
                    :class="[getGroupClass(groupKey), { 'dragging': currentDrag === idx, 'drag-over': hoverIndex === idx && currentDrag !== null && currentDrag !== idx }]"
                    v-show="shouldShowGroup(groupKey)"
                    :ref="`group-${idx}`"
                >
                    <div class="group-header" @click.stop="toggleGroup(groupKey)">
                        <div
                            class="drag-handle"
                            @mousedown="startDrag($event, idx)"
                        >
                            <i class="material-icons">drag_indicator</i>
                        </div>
                        <span class="group-title">{{ getGroupTitle(groupKey) }}</span>
                        <a
                            v-if="groupKey === 'properties'"
                            class="group-settings-link"
                            @click.stop="navigateToProfileFields"
                        >
                            <i class="material-icons">settings</i>
                        </a>
                        <i class="material-icons">{{ getGroupState(groupKey) ? 'expand_less' : 'expand_more' }}</i>
                    </div>
                    <div class="drag-placeholder" v-if="hoverIndex === idx && currentDrag !== null && currentDrag !== idx">
                        <span>{{ $t('chat.contactDetail.dragPlaceholder') }}</span>
                    </div>
                    <div class="group-content" v-if="getGroupState(groupKey)" v-show="!(hoverIndex === idx && currentDrag !== null && currentDrag !== idx)">
                            <template v-if="groupKey === 'basic'">
                                <ContactDetailItem
                                    :contact="contact"
                                    :label="$t('message.fullName')"
                                    :value="getVal('fullname', 'N/A', false)"
                                    :showEdit="true"
                                    :showDelete="false"
                                    :showCopy="true"
                                    @edit="updateContactDetailKey('fullname', $event)"
                                    @add="addContactDetailKey('fullname', $event)"
                                >
                                    <template #icon>
                                        <div class="material-icons">person</div>
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    :contact="contact"
                                    :label="$t('message.email')"
                                    :value="getVal('email')"
                                    :showEdit="true"
                                    :showDelete="false"
                                    :showCopy="true"
                                    field="email"
                                    @edit="updateContactDetailKey('email', $event)"
                                    @add="addContactDetailKey('email', $event)"
                                >
                                    <template #icon>
                                        <div class="material-icons">alternate_email</div>
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    :contact="contact"
                                    :label="$t('message.phoneNumber') || 'Telefon Numarası'"
                                    :value="maskContactInfo('phone', contact.phone, 5)"
                                    :showEdit="true"
                                    :showDelete="false"
                                    :showCopy="true"
                                    field="phone"
                                    @edit="updateContactDetailKey('phone', $event)"
                                    @add="addContactDetailKey('phone', $event)"
                                >
                                    <template #icon>
                                        <div class="material-icons">phone</div>
                                    </template>
                                </ContactDetailItem>
                                  <ContactDetailItem
                                    :contact="contact"
                                    :label="'Whatsapp ID'"
                                    :value="contact.whatsappId"
                                    :showEdit="false"
                                    :showDelete="false"
                                    :showCopy="true"
                                    field="whatsappId"
                                >
                                    <template #icon>
                                        <div class="material-icons">alternate_email</div>
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    :contact="contact"
                                    :label="$t('message.preferredLanguage')"
                                    :value="getPreferredLang()"
                                    :showEdit="true"
                                    :showDelete="false"
                                    :showCopy="true"
                                    field="preferredLang"
                                    @edit="updatePreferredLang"
                                >
                                    <template #icon>
                                        <FlagSvg />
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    :contact="contact"
                                    :label="$t('whatsappChannel.channelName')"
                                    :value="getChannelName() || getPlatformName()"
                                    :showEdit="false"
                                    :showDelete="false"
                                    :showCopy="true"
                                >
                                    <template #icon>
                                        <PlatformIcon
                                            :platform="getChannelType"
                                            :size="20"
                                            v-tippy="{ content: getPlatformName() }"
                                        />
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    v-if="contact.lastConversation && contact.lastConversation.subject"
                                    :contact="contact"
                                    :label="$t('chat.contactDetail.currentConversationDepartment')"
                                    :value="subjectName(contact.lastConversation.subject)"
                                    :showEdit="false"
                                    :showDelete="false"
                                    :showCopy="true"
                                >
                                    <template #icon>
                                        <Department style="width: 20px; height: 20px" />
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    v-if="contact.relatedDepartments && contact.relatedDepartments.length > 0"
                                    :contact="contact"
                                    :label="$t('chat.contactDetail.pastInteractionDepartments')"
                                    :value="getRelatedDepartmentsNames()"
                                    :showEdit="false"
                                    :showDelete="false"
                                    :showCopy="true"
                                >
                                    <template #icon>
                                        <Department style="width: 20px; height: 20px; opacity: 0.7;" />
                                    </template>
                                </ContactDetailItem>
                                 <ContactDetailItem
                                    :contact="contact"
                                    :label="$t('visitor.tags')"
                                    :value="contact.tags"
                                    :showEdit="true"
                                    :showDelete="false"
                                    :showCopy="true"
                                    field="tags"
                                    @edit="updateTags"
                                >
                                    <template #icon>
                                        <TagSvg />
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    v-if="contact.platform === 'web'"
                                    :contact="contact"
                                    :label="$t('message.visitingPage')"
                                    :value="contact.visitingPage"
                                    :showEdit="false"
                                    :showDelete="false"
                                    :showCopy="true"
                                    :showAdd="false"
                                >
                                    <template #icon>
                                        <BrowserSvg />
                                    </template>
                                </ContactDetailItem>

                            </template>
                            <template v-else-if="groupKey === 'loginInfo'">
                                <ContactDetailItem
                                    :contact="contact"
                                    v-for="inputValue of getCustomLoginInfos()"
                                    :label="inputValue.name"
                                    :value="inputValue.value"
                                    :key="inputValue.id"
                                    :showDelete="false"
                                    :showEdit="false"
                                    :showAdd="false"
                                    @updated="updateCustomLoginFormInfo(inputValue, $event)"
                                >
                                    <template #icon>
                                        <div class="material-icons">alternate_email</div>
                                    </template>
                                    <template #value>
                                        {{ inputValue.value }}
                                    </template>
                                </ContactDetailItem>
                            </template>
                            <template v-else-if="groupKey === 'properties'">
                                <ContactProperties :contact="contact" :show-widget-title="false" />
                            </template>
                            <template v-else-if="groupKey === 'system'">

                                <ContactDetailItem
                                    v-if="getVal('languageCode', null)"
                                    :contact="contact"
                                    :label="$t('message.countryAndLanguage')"
                                    :value="getCountryAndLanguage()"
                                    :showEdit="false"
                                    :showDelete="false"
                                    :showCopy="true"
                                >
                                    <template #icon>
                                        <FlagSvg />
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    v-if="getOs() !== 'N/A'"
                                    :contact="contact"
                                    :label="$t('message.os_browser')"
                                    :value="getOs()"
                                    :showEdit="false"
                                    :showDelete="false"
                                    :showCopy="true"
                                >
                                    <template #icon>
                                        <BrowserSvg />
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    v-if="getVal('ipAddress', null)"
                                    :contact="contact"
                                    :label="$t('message.ipAddress')"
                                    :value="getVal('ipAddress')"
                                    :showEdit="false"
                                    :showDelete="false"
                                    :showCopy="true"
                                >
                                    <template #icon>
                                        <BrowserSearchSvg />
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    :contact="contact"
                                    :label="$t('userInfoWidget.speechID')"
                                    :value="getVal('lastConversation._id')"
                                    :showEdit="false"
                                    :showDelete="false"
                                    :showCopy="true"
                                >
                                    <template #icon>
                                        <UserCardSvg />
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    :contact="contact"
                                    :label="$t('message.visitorId')"
                                    :value="getVal('_id')"
                                    :showEdit="false"
                                    :showDelete="false"
                                    :showCopy="true"
                                >
                                    <template #icon>
                                        <FingerSvg />
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    v-if="getVal('createdAt', null, false)"
                                    :contact="contact"
                                    :label="$t('chat.contactDetail.createdAt')"
                                    :value="formatCreatedAt()"
                                    :showEdit="false"
                                    :showDelete="false"
                                    :showCopy="true"
                                >
                                    <template #icon>
                                        <div class="material-icons">event</div>
                                    </template>
                                </ContactDetailItem>
                                <ContactDetailItem
                                    :contact="contact"
                                    :label="$t('chat.contactDetail.updatedAt')"
                                    :value="getUpdatedAtDisplayValue()"
                                    :showEdit="false"
                                    :showDelete="false"
                                    :showCopy="true"
                                >
                                    <template #icon>
                                        <div class="material-icons">schedule</div>
                                    </template>
                                </ContactDetailItem>
                            </template>
                        </div>
                    </div>
            </div>
        </div>
        <TagDialog
            v-if="showTagDialog"
            :value="getContactTagIds()"
            @input="contactTagUpdated"
            @close="showTagDialog = false"
        />
    </div>
</template>
<script>
import ContactSvg from "./svg/ContactSvg.vue";
import FlagSvg from "./svg/FlagSvg.vue";
import AgentsInfoSvg from "./svg/AgentsInfoSvg.vue";
import BrowserSvg from "./svg/BrowserSvg.vue";
import BrowserSearchSvg from "./svg/BrowserSearchSvg.vue";
import UserCardSvg from "./svg/UserCardSvg.vue";
import FingerSvg from "./svg/FingerSvg.vue";
import TagSvg from "./svg/TagSvg.vue";
import { mapActions, mapState } from "vuex";
import ContactDetailItem from "./ContactDetailItem.vue";
import CountryFlag from "vue-country-flag";
import countryCodes from "../../../utils/countryCodes";
import ContactAvatar from "./ContactAvatar.vue";
import _ from "lodash";
import SupsisButton from "../../../views/Pages/Settings/components/SupsisButton.vue";
import TagDialog from "../../TagDialog.vue";
import { sendSocketMessage } from "../../../utils/socketStream";
import UpdateContactLang from "./UpdateContactLang.vue";
import languages from "../../../language/languages.json";
import webIcon from "../../../views/Pages/Visitors/components/svg/WebIcon.vue";
import InstagramIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/InstagramIcon.vue";
import WhatsappIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import MetaIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/MetaIcon.vue";
import TelegramIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/TelegramIcon.vue";
import MessengerIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import TrendyolIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/TrendyolIcon.vue";
import BrowserSvg2 from "./svg/Browser2Svg.vue";
import WhatsappSvg from "./svg/WhatsappSvg.vue";
import PlatformIcon from "./ChatMessageArea/components/PlatformIcon.vue";
import WhatsappChatStarter from "../../../views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue";
import Modal2 from "../../common/Modal2.vue";
import ContactProperties from "./ContactProperties.vue";
import Department from "./svg/Department.vue";
import { isMaskContactInfo, maskContactInfo } from "../../../utils/utils";
import LinkedinIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/LinkedinIcon.vue";
import AgentAvatar from "../../common/AgentAvatar.vue";
import ChatForwardWindow from "../../../views/Pages/Chat/components/ChatForwardWindow.vue";
import mailIcon from "../../../views/Pages/Mail/icons/MailIcon.vue";

export default {
    name: "ContactDetail",
    components: {
        LinkedinIcon,
        AgentAvatar,
        ChatForwardWindow,
        mailIcon,
        ContactProperties,
        PlatformIcon,
        WhatsappSvg,
        BrowserSvg2,
        MessengerIcon,
        TelegramIcon,
        TrendyolIcon,
        MetaIcon,
        WhatsappIcon,
        InstagramIcon,
        webIcon,
        UpdateContactLang,
        TagDialog,
        SupsisButton,
        ContactAvatar,
        ContactDetailItem,
        TagSvg,
        FingerSvg,
        UserCardSvg,
        BrowserSearchSvg,
        BrowserSvg,
        AgentsInfoSvg,
        FlagSvg,
        ContactSvg,
        CountryFlag,
        WhatsappChatStarter,
        Modal2,
        Department,
    },
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
        showProfileTop: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        showTagDialog: false,
        showWhatsappChatStarterModal: false,
        showOwnerModal: false,
        showContactProperties: localStorage.getItem("showContactProperties") === "true" || false,
        showSystemInfo: localStorage.getItem("showSystemInfo") === "true" || false,
        showBasicInfo: localStorage.getItem("showBasicInfo") === "true" || true,
        showLoginInfo: localStorage.getItem("showLoginInfo") === "true" || false,
        isMinimized: localStorage.getItem("contactDetailMinimized") === "true" || false,
        groupOrder: JSON.parse(localStorage.getItem("contactDetailGroupOrder") || '["basic", "loginInfo", "properties", "system"]'),
        currentDrag: null,
        hoverIndex: null,
        dragStartY: 0,
    }),
    computed: {
        ...mapState({
            authUser: (state) => state.auth.user,
            users: (state) => state.user.users.data,
            site: (state) => state.site.site,
            liveVisitors: (state) => state.visitor.liveVisitors,
            inputs: (state) =>
                state.customLoginForm.inputs.reduce((acc, cur) => {
                    acc[cur._id] = cur;
                    return acc;
                }, {}),
            subjects: (state) => state.subject.subjects.data,
            channels: (state) => state.channel.channels,
            allContactProperties: (state) => state.contactProperty.data || [],
            zohoChannelExists: (state) => !!state.channel.channels.some((channel) => channel.type === "zoho"),
            maskSensitiveInfo: (state) => state.setting.settings.maskSensitiveInfo,
            isRoot: (state) => _.get(state, "auth.user.role.isRoot", false),
        }),
        getChannelType() {
            if (this.contact.platform === "whatsapp") {
                const channel = this.channels.find((channel) => channel._id === this.contact.channel);
                return channel ? channel.type : "notWp";
            }
            return this.contact.platform;
        },
        visibleGroups() {
            return this.groupOrder.filter(groupKey => this.shouldShowGroup(groupKey));
        },
    },
    mounted() {
        this.getTags("contact");
    },
    beforeDestroy() {
        this.onDragEnd();
    },
    methods: {
        navigateToProfileFields() {
            this.$router.push({
                path: '/visitors',
                query: { tab: 'profile-fields' }
            });
        },
        isMaskContactInfo,
        isShouldMask(val) {
            return (
                !this.isRoot &&
                this.maskSensitiveInfo &&
                (val === this.contact.email || val === this.contact.whatsappNumber || val === this.contact.phone)
            );
        },
        maskContactInfo(key, val, length = 4) {
            return isMaskContactInfo(key)
                ? maskContactInfo(val, length)
                : this.isShouldMask(val)
                ? maskContactInfo(val, length)
                : val;
        },
        ...mapActions({
            addNewWindow: "app/addNewWindow",
            updateVisitorTags: "visitor/updateTagVisitor",
            createNote: "visitor/createVisitorNote",
            updateContactFields: "contact/updateContactFields",
            updateVisitorAttr: "visitor/updateVisitorAttr",
            updateCustomLoginInfo: "chat/updateCustomLoginInfo",
            getTags: "tag/getTags",
        }),
        updateCustomLoginFormInfo(input, value) {
            const customLoginInfos = this.contact.lastConversation.customLoginInfos.map((item) => {
                if (item.input === input.id) {
                    item.value = value;
                }
                return item;
            });
            this.updateCustomLoginInfo({
                conversationId: this.contact.lastConversation._id,
                customLoginInfos,
            }).then(() => {
                this.updateContactFields({
                    contactId: this.contact._id,
                    set: {
                        lastConversation: {
                            ...this.contact.lastConversation,
                            customLoginInfos,
                        },
                    },
                });
            });
        },
        updateContactDetailKey(field, value) {
            const updateContact = () => {
                this.updateVisitorAttr({
                    visitorId: this.contact._id,
                    payload: {
                        [field]: value,
                    },
                }).then(() => {
                    this.updateContactFields({
                        contactId: this.contact._id,
                        set: {
                            [field]: value,
                        },
                    });

                    const payload = {
                        siteId: this.site._id,
                        visitorId: this.contact._id,
                        updatingFields: {
                            [field]: value,
                        },
                        oldOwner: this.contact.owner,
                        lastConversationId: this.$_.get(this.contact, "lastConversation._id"),
                        autUser: this.authUser._id,
                    };

                    if (field === "owner") {
                        const isActiveConversation = this.$_.get(this.contact, "lastConversation.status") === "active";
                        if (isActiveConversation) payload.conversationId = this.contact.lastConversation._id;
                    }

                    if (field === "owner" && this.zohoChannelExists) {
                        this.$confirm({
                            title: this.$t('chat.contactDetail.zohoSync'),
                            content: this.$t('chat.contactDetail.zohoSyncQuestion'),
                            onOk: () => {
                                payload.publishToZoho = true;
                                sendSocketMessage("visitor profile-updated", payload);
                            },
                            onCancel: () => {
                                sendSocketMessage("visitor profile-updated", payload);
                            },
                        });
                    } else {
                        sendSocketMessage("visitor profile-updated", payload);
                    }
                });
            };

            updateContact();
        },
        getPlatform() {
            const platform = this.contact.platform;
            if (!this.contact.channel) return this.getPlatformName();
            const channelsMap = this.channels.reduce((acc, cur) => {
                acc[cur._id] = cur;
                return acc;
            }, {});
            const channel = channelsMap[this.contact.channel];
            if (channel && channel.name) {
                return `${this.getPlatformName()} / ${channel.name}`;
            }
            return this.getPlatformName();
        },
        getPlatformName() {
            const platformMap = {
                whatsapp: "WhatsApp",
                telegram: "Telegram",
                messenger: "Messenger",
                web: "Web",
                email: "Email",
                "meta-leads": "Meta",
                instagram: "Instagram",
                linkedin: "LinkedIn",
                trendyol: "Trendyol",
            };
            return platformMap[this.contact.platform] || this.contact.platform;
        },
        getChannelName() {
            if (!this.contact.channel) return null;
            const channel = this.channels.find((item) => item._id === this.contact.channel);
            return channel?.name || null;
        },
        getContactTagIds() {
            return this.contact.tags?.map((tag) => (typeof tag === "string" ? tag : tag._id)) || [];
        },
        contactTagUpdated: _.debounce(function (v) {
            this.updateContactFields({
                contactId: this.contact._id,
                set: {
                    tags: v,
                },
            });
            this.updateVisitorTags({
                visitorId: this.contact._id,
                tagIds: v,
            });
        }, 300),
        saveContactLanguage(preferredLang) {
            sendSocketMessage("visitor lang-change", {
                visitorId: this.contact._id,
                siteId: this.site._id,
                preferredLang: preferredLang,
                conversationId: this.contact.lastConversation._id,
            });
            sendSocketMessage("visitor profile-updated", {
                visitorId: this.contact._id,
                siteId: this.site._id,
                updatingFields: {
                    preferredLang,
                },
            });
            this.updateContactFields({
                contactId: this.contact._id,
                set: {
                    preferredLang,
                },
            });
        },
        getTagsName() {
            return (
                (this.contact.tags || [])
                    .map((tag) => tag?.name)
                    .filter((s) => s)
                    .join(",") || "-"
            );
        },
        getVal(path, defaultVal = "N/A", mask = true) {
            return mask
                ? this.maskContactInfo(path, _.get(this.contact, path, defaultVal))
                : _.get(this.contact, path, defaultVal);
        },
        getAgents(isString = false) {
            const usersHash = this.users.reduce((acc, user) => {
                acc[user._id] = user;
                return acc;
            }, {});
            const agentIds = this.getVal("users", []);
            const arr = agentIds.map((agentId) => usersHash[agentId]);
            return isString ? arr.map((val) => val.name || "Bilinmiyor").join(",") : arr;
        },
        getCountryName(country = "") {
            const q = country.toLowerCase().trim();
            const maybeCountry = countryCodes.find(
                (x) => x.name.toLowerCase().trim() === q || x.code.toLowerCase().trim() === q
            );
            return maybeCountry ? maybeCountry.name : country;
        },
        getOs() {
            return this.contact.platform === "web"
                ? this.contact.os || this.contact.browser
                    ? this.contact.os + "/" + this.contact.browser
                    : "N/A"
                : this.getPlatformName();
        },
        IsVisitorOnline() {
            if (this.contact.channel) return true;
            const isWhatsappVisitor = !!_.get(this.contact, "whatsappNumber");
            const isInstagramVisitor = !!_.get(this.contact, "instagramUserId");
            const isMessengerVisitor = !!_.get(this.contact, "messengerUserId");
            const isTelegramVisitor = !!_.get(this.contact, "telegramUserId");
            const isLinkedinVisitor = !!_.get(this.contact, "linkedinUserId");
            if (isWhatsappVisitor || isInstagramVisitor || isTelegramVisitor || isMessengerVisitor || isLinkedinVisitor)
                return true;
            else return this.liveVisitors.includes(this.contact._id);
        },
        viewContactProfile() {
            this.addNewWindow({
                type: "show-visitor",
                title: this.contact.fullname,
                payload: {
                    visitorId: this.contact._id,
                },
                footer: false,
            });
        },
        getSubjectName(id) {
            let maybeSubject = this.subjects.find((x) => x._id == id);
            return maybeSubject ? maybeSubject.languageContent[this.$i18n.locale].name : undefined;
        },
        getCustomLoginInfos() {
            let inputValues = this.contact.lastConversation.customLoginInfos || [];
            const hashMapContactProperty = (this.contact?.contactProperties || []).reduce((a, b) => {
                a[b.property._id] = true;
                return a;
            }, {});

            inputValues = inputValues
                .filter((x) => this.inputs[x.input])
                .filter((x) => !["email", "fullname", "subject", "json"].includes(this.inputs[x.input].type))
                .filter((x) => !hashMapContactProperty[this.inputs[x.input]?.contactProperty])
                .map((v) => {
                    const current = this.inputs[v.input];
                    const langs = Object.keys(_.get(current, "localizedLabel", {}));
                    const lang = langs.includes(this.$i18n.locale) ? this.$i18n.locale : langs[0];
                    const name = _.get(current, `localizedLabel.${lang}.text`, "");
                    const isSubject = _.get(current, "type") === "subject";
                    return {
                        value: isSubject ? this.getSubjectName(v.value) : v.value,
                        name,
                        id: _.get(current, "_id"),
                    };
                });
            return inputValues;
        },
        getCountryAndLanguage() {
            return `${this.getCountryName(this.getVal("languageCode"))} / ${this.getVal("languageCode")}`;
        },
        getPreferredLang() {
            return languages.find((lang) => lang.code === this.contact.preferredLang)?.originalName;
        },
        updatePreferredLang(newLang) {
            this.updateContactDetailKey("preferredLang", newLang);
        },
        updateTags(newTags) {
            this.updateContactFields({
                contactId: this.contact._id,
                set: {
                    tags: newTags,
                },
            });
            this.updateVisitorTags({
                visitorId: this.contact._id,
                tagIds: newTags,
            });
        },
        startWhatsappChat() {
            this.$emit("start-whatsapp-chat", this.contact.whatsappNumber);
        },
        addContactDetailKey(field, value) {
            this.updateVisitorAttr({
                visitorId: this.contact._id,
                payload: {
                    [field]: value,
                },
            }).then(() => {
                this.updateContactFields({
                    contactId: this.contact._id,
                    set: {
                        [field]: value,
                    },
                });
                sendSocketMessage("visitor profile-updated", {
                    siteId: this.site._id,
                    visitorId: this.contact._id,
                    updatingFields: {
                        [field]: value,
                    },
                });
            });
        },
        subjectName(subjectId) {
            const subject = this.subjects.find((x) => x._id == subjectId);
            return this.$_.get(subject, `languageContent[${this.$i18n.locale}].name`, "");
        },
        getRelatedDepartmentsNames() {
            if (!this.contact.relatedDepartments || this.contact.relatedDepartments.length === 0) {
                return "-";
            }
            const departmentNames = this.contact.relatedDepartments
                .map((deptId) => {
                    const dept = this.subjects.find((x) => x._id == deptId);
                    return this.$_.get(dept, `languageContent[${this.$i18n.locale}].name`, null);
                })
                .filter((name) => name);
            return departmentNames.length > 0 ? departmentNames.join(", ") : "-";
        },
        getGroupClass(groupKey) {
            const classMap = {
                basic: "basic-info-group",
                loginInfo: "login-info-group",
                properties: "contact-properties-group",
                system: "system-info-group",
            };
            return classMap[groupKey] || "";
        },
        getGroupTitle(groupKey) {
            const titleMap = {
                basic: this.$t('chat.contactDetail.basicInfo'),
                loginInfo: this.$t('chat.contactDetail.loginInfo'),
                properties: this.$t('chat.contactDetail.profileFields'),
                system: this.$t('chat.contactDetail.systemInfo'),
            };
            return titleMap[groupKey] || "";
        },
        getGroupState(groupKey) {
            const stateMap = {
                basic: this.showBasicInfo,
                loginInfo: this.showLoginInfo,
                properties: this.showContactProperties,
                system: this.showSystemInfo,
            };
            return stateMap[groupKey] || false;
        },
        startDrag(e, index) {
            e.preventDefault();
            e.stopPropagation();

            this.currentDrag = index;
            this.dragStartY = e.clientY;

            document.addEventListener("mousemove", this.onDragMove);
            document.addEventListener("mouseup", this.onDragEnd);

            document.body.style.cursor = "grabbing";
            document.body.style.userSelect = "none";
        },
        onDragMove(e) {
            if (this.currentDrag === null) return;

            const container = this.$refs.groupsContainer;
            if (!container) return;

            const groups = container.children;
            const mouseY = e.clientY;

            let newIndex = this.currentDrag;
            let hoverIdx = null;

            for (let i = 0; i < groups.length; i++) {
                const group = groups[i];
                const rect = group.getBoundingClientRect();

                if (mouseY >= rect.top && mouseY <= rect.bottom && i !== this.currentDrag) {
                    hoverIdx = i;
                    const middle = rect.top + rect.height / 2;

                    if (mouseY < middle && i < this.currentDrag) {
                        newIndex = i;
                        break;
                    } else if (mouseY > middle && i > this.currentDrag) {
                        newIndex = i;
                    }
                }
            }

            this.hoverIndex = hoverIdx;

            if (newIndex !== this.currentDrag) {
                const newOrder = [...this.groupOrder];
                const item = newOrder.splice(this.currentDrag, 1)[0];
                newOrder.splice(newIndex, 0, item);
                this.groupOrder = newOrder;
                this.currentDrag = newIndex;
                this.hoverIndex = null;
            }
        },
        onDragEnd() {
            if (this.currentDrag !== null) {
                localStorage.setItem("contactDetailGroupOrder", JSON.stringify(this.groupOrder));
            }

            this.currentDrag = null;
            this.hoverIndex = null;
            this.dragStartY = 0;

            document.removeEventListener("mousemove", this.onDragMove);
            document.removeEventListener("mouseup", this.onDragEnd);

            document.body.style.cursor = "";
            document.body.style.userSelect = "";
        },
        toggleVipCustomer() {
            const newVipStatus = !this.contact.vipCustomer;
            this.updateContactFields({
                contactId: this.contact._id,
                set: {
                    vipCustomer: newVipStatus,
                },
            });
            this.updateVisitorAttr({
                visitorId: this.contact._id,
                payload: {
                    vipCustomer: newVipStatus,
                },
            });
        },
        toggleMinimize() {
            this.isMinimized = !this.isMinimized;
            localStorage.setItem("contactDetailMinimized", this.isMinimized);
        },
        getOwnerName(ownerId) {
            if (!ownerId) return null;
            const user = this.users.find((u) => u._id === ownerId);
            return user ? user.name : null;
        },
        assignToMe() {
            this.updateContactDetailKey("owner", this.authUser._id);
        },
        removeOwner() {
            this.updateContactDetailKey("owner", null);
        },
        toggleGroup(groupKey) {
            const toggleMap = {
                basic: () => { this.showBasicInfo = !this.showBasicInfo; },
                loginInfo: () => { this.showLoginInfo = !this.showLoginInfo; },
                properties: () => { this.showContactProperties = !this.showContactProperties; },
                system: () => { this.showSystemInfo = !this.showSystemInfo; },
            };
            if (toggleMap[groupKey]) {
                toggleMap[groupKey]();
            }
        },
        shouldShowGroup(groupKey) {
            if (groupKey === "loginInfo") {
                return this.getCustomLoginInfos().length > 0;
            }
            if (groupKey === "properties") {
                return this.allContactProperties && this.allContactProperties.length > 0;
            }
            return true;
        },
        formatCreatedAt() {
            const createdAt = this.getVal('createdAt', null, false);
            if (!createdAt || createdAt === 'N/A') return 'N/A';
            return this.$moment(createdAt).format('DD/MM/YYYY HH:mm');
        },
        formatUpdatedAt() {
            const updatedAt = this.contact.updatedAt || this.$_.get(this.contact, 'updatedAt', null);
            if (!updatedAt || updatedAt === 'N/A' || updatedAt === null) return 'N/A';
            try {
                return this.$moment(updatedAt).format('DD/MM/YYYY HH:mm');
            } catch (e) {
                return 'N/A';
            }
        },
        getUpdatedAtDisplayValue() {
            return this.formatUpdatedAt();
        },
        getInstagramFollowInfo() {
            const instagramInfo = _.get(this.contact, 'instagramInfo', {});
            return {
                userFollowsBusiness: instagramInfo.is_user_follow_business === true,
                businessFollowsUser: instagramInfo.is_business_follow_user === true,
                isVerified: instagramInfo.is_verified_user === true,
                followerCount: instagramInfo.follower_count || 0,
            };
        },
    },
    watch: {
        showContactProperties: function (val) {
            localStorage.setItem("showContactProperties", val);
        },
        showSystemInfo: function (val) {
            localStorage.setItem("showSystemInfo", val);
        },
        showBasicInfo: function (val) {
            localStorage.setItem("showBasicInfo", val);
        },
        showLoginInfo: function (val) {
            localStorage.setItem("showLoginInfo", val);
        },
    },
};
</script>
<style lang="scss" scoped>
.contact-details {
    display: flex;
    flex-direction: column;

    .user-info-profile {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        border: none;
        border-radius: 0;
        background-color: transparent;
        margin-bottom: 12px;

        .profile-header {
            display: flex;
            flex-direction: column;
            width: 100%;
            padding: 12px 16px;
            transition: padding 0.3s ease;

            &:hover {
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
            }

            &.minimized {
                padding: 8px 16px;
            }

            .profile-top-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 12px;
                width: 100%;

                .profile-main {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    flex: 1;
                    cursor: pointer;
                    min-width: 0;

                    .avatar-wrapper {
                        position: relative;
                        flex-shrink: 0;
                        transition: transform 0.3s ease;

                        &.minimized {
                            transform: scale(0.7);
                            opacity: 0.8;
                        }

                        .platform-badge {
                            position: absolute;
                            bottom: -3px;
                            right: -3px;
                            width: 24px;
                            height: 24px;
                            background: white;
                            border: 2px solid white;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
                            z-index: 1;

                            .platform-icon {
                                width: 16px;
                                height: 16px;
                            }
                        }
                    }

                    .name-info {
                        display: flex;
                        flex-direction: column;
                        gap: 4px;
                        min-width: 0;
                        flex: 1;

                        .name-row {
                            display: flex;
                            align-items: center;
                            gap: 8px;
                            width: 100%;
                        }

                        .contact-profile-fullname {
                            font-weight: 600;
                            font-size: 15px;
                            color: #1f2937;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            flex: 1;
                            min-width: 0;

                            .instagram-username {
                                font-weight: 400;
                                font-size: 13px;
                                color: #6b7280;
                                margin-left: 6px;
                                text-decoration: none;
                                transition: color 0.2s ease;
                                cursor: pointer;

                                &:hover {
                                    color: #3b82f6;
                                    text-decoration: underline;
                                }
                            }
                        }

                        .vip-star-btn {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                            width: 24px;
                            height: 24px;
                            border-radius: 50%;
                        cursor: pointer;
                            transition: all 0.2s ease;
                            color: #9ca3af;
                            flex-shrink: 0;
                            background: transparent;

                        &:hover {
                            background-color: #f3f4f6;
                                color: #6b7280;
                                transform: scale(1.1);
                        }

                        .material-icons {
                                font-size: 20px;
                                transition: all 0.2s ease;
                        }

                            &.active {
                                color: #f59e0b;
                                background: linear-gradient(135deg, rgba(214, 234, 45, 0.15), rgba(249, 96, 203, 0.15), rgba(144, 55, 212, 0.15));

                                .material-icons {
                                    background: linear-gradient(135deg, #d6ea2d, #f960cb, #9037d4);
                                    -webkit-background-clip: text;
                                    background-clip: text;
                                    -webkit-text-fill-color: transparent;
                                    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
                        }

                            &:hover {
                                    background: linear-gradient(135deg, rgba(214, 234, 45, 0.25), rgba(249, 96, 203, 0.25), rgba(144, 55, 212, 0.25));
                                    transform: scale(1.15);
                                }
                            }
                        }

                        .whatsapp-number {
                            cursor: pointer;
                            color: #3b82f6;
                            text-decoration: underline;
                            font-size: 12px;

                            &:hover {
                                color: #2563eb;
                            }
                        }
                        
                        .instagram-follow-info {
                            display: flex;
                            flex-direction: column;
                            gap: 4px;
                            margin-top: 4px;
                            
                            .follow-badge {
                                display: flex;
                                align-items: center;
                                gap: 4px;
                                font-size: 11px;
                                padding: 2px 8px;
                                border-radius: 12px;
                                width: fit-content;
                                
                                .material-icons {
                                    font-size: 14px;
                                }
                                
                                &.user-follows {
                                    background-color: rgba(59, 130, 246, 0.1);
                                    color: #3b82f6;
                                    
                                    .material-icons {
                                        color: #3b82f6;
                                    }
                                }
                                
                                &.business-follows {
                                    background-color: rgba(16, 185, 129, 0.1);
                                    color: #10b981;
                                    
                                    .material-icons {
                                        color: #10b981;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .profile-meta-section {
                margin-top: 12px;
                padding-top: 12px;
                border-top: 1px solid #e8e8e8;

                .meta-label {
                    font-size: 11px;
                    font-weight: 600;
                    color: #6b7280;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-bottom: 8px;
                }

                .meta-content {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;

                    .owner-row {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 8px;
                    }

                    .owner-info {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        padding: 6px 10px;
                        background-color: #f3f4f6;
                        border-radius: 6px;
                        cursor: pointer;
                        transition: background-color 0.2s;
                        max-width: fit-content;

                        &:hover {
                            background-color: #e5e7eb;
                        }

                        .owner-name {
                            font-size: 13px;
                            color: #374151;
                            font-weight: 500;
                            white-space: nowrap;
                        }

                        .owner-settings-icon {
                            font-size: 16px;
                            color: #6b7280;
                            margin-left: 4px;
                            transition: color 0.2s;
                        }

                        &:hover .owner-settings-icon {
                            color: #374151;
                        }
                    }

                    .owner-actions {
                        display: flex;
                        gap: 4px;
                        flex-shrink: 0;

                        .owner-action-btn {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 32px;
                            height: 32px;
                            padding: 0;
                            border: none;
                            background: transparent;
                            color: #6b7280;
                            cursor: pointer;
                            transition: color 0.2s ease;

                            .material-icons {
                                font-size: 20px;
                                transition: color 0.2s ease;
                            }

                            &.assign-to-me-btn {
                                color: #6b7280;

                                &:hover {
                                    color: #3b82f6;
                                }
                            }

                            &.remove-owner-btn {
                                color: #6b7280;

                                &:hover {
                                    color: #ef4444;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .user-info-details-wrapper {
        display: flex;
        flex-direction: column;
        gap: 0;

        .user-info-details-content {
            display: flex;
            flex-direction: column;
            gap: 0;
        }
    }

    .basic-info-group,
    .login-info-group,
    .contact-properties-group,
    .system-info-group {
        display: flex;
        flex-direction: column;
        transition: transform 0.2s;
        border-bottom: 1px solid #e8e8e8;
        pointer-events: auto;

        &.dragging {
            opacity: 0.5;
            transition: opacity 0.2s;
        }

        &.drag-over {
            .group-content {
                display: none;
            }
        }

        .group-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 10px;
            cursor: pointer;
            transition: background-color 0.2s;
            background-color: #f9fafb;

            &:hover {
                background-color: #f3f4f6;
                .drag-handle {
                    opacity: 1;
                }
            }

            .group-settings-link {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 8px;
                color: #6b7280;
                text-decoration: none;
                transition: color 0.2s;
                padding: 4px;
                border-radius: 4px;

                &:hover {
                    color: #22272d;
                    background-color: rgba(0, 0, 0, 0.05);
                }

                .material-icons {
                    font-size: 18px;
                }
            }

            .drag-handle {
                cursor: grab;
                margin-right: 8px;
                color: #999;
                display: flex;
                align-items: center;
                transition: color 0.2s, opacity 0.2s;
                opacity: 0;

                &:active {
                    cursor: grabbing;
                }

                &:hover {
                    color: #666;
                }

                .material-icons {
                    font-size: 18px;
                }
            }

            .group-title {
                font-weight: 500;
                font-size: 14px;
                color: #333;
                flex: 1;
            }

            .material-icons {
                font-size: 20px;
                color: #666;
                transition: transform 0.2s;
            }
        }

        .drag-placeholder {
            padding: 40px 20px;
            background-color: #e5e7eb;
            border-radius: 4px;
            margin: 8px 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 60px;

            span {
                color: #6b7280;
                font-size: 13px;
                font-weight: 500;
            }
        }

        .group-content {
            padding: 0 20px;
            display: flex;
            flex-direction: column;
            gap: 0;
        }
    }
}
</style>
<style lang="scss">
.basic-info-group,
.login-info-group,
.contact-properties-group,
.system-info-group {
    .group-content {
        .widget-content {
            padding: 0 !important;

            .drag-row {
                padding: 0 !important;
            }
        }
    }
}
</style>
